import { redirectToErrorPage } from './handlers/navigation';
import model from './model';
import { pageReady } from './viewer-controller';
import { getContext } from './viewer-controller/context';

export default model.createController((props) => {
  const { contextProps, contextServices } = getContext(props);

  return {
    pageReady: async () => {
      try {
        await contextServices.monitoringService.toMonitored(
          'controller.page_ready',
          () => pageReady(contextProps, contextServices),
        );
      } catch (error) {
        redirectToErrorPage(contextProps, contextServices, error);
      }
    },
    exports: {},
  };
});
